import styled from "styled-components";

export const CheckoutStyled = styled.div`
  border: 2px solid #fdca31;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 20px #00000029;
  padding: 20px;
  box-sizing: border-box;
  .checkout {
    &-title {
      text-align: center;
      margin-bottom: 40px;
    }
  }
`;
